import { Component } from '@angular/core';
import { Globals } from '../../../../../globals';
import { NavController } from 'ionic-angular';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { TpvPanelPage } from '../../../../tpv/tpv-panel/tpv-panel';
import { SalesListPage } from '../../../../sales/sales-list/sales-list';
import { AnalyticsServices } from '../../../../services/analyticsServices';

@Component({
    selector: 'page-home-pos',
    templateUrl: 'home-pos.html'
})

export class HomePosPage {
    sales_day: any = 0;
    sales_tips: any = 0;
    total_tips: any = 0;
    total_elements_sold: any = 0;
    data_sales_day: boolean = false;

    constructor(public globals: Globals,
        public navCtrl: NavController,
        public http: HttpClient,
        public analyticsServices: AnalyticsServices) {
    }

    ngOnInit() {
        this.salesDay();
        //Enviar plg_pos_starter a bigquery si el restaurante es finisher pero no starter porque ha entrado directamente a la app
        if (this.globals.restaurant.plg_pos_finisher && !this.globals.restaurant.plg_pos_starter) {
            this.globals.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
                plg_pos_starter: true
            });
            this.globals.restaurant.plg_pos_starter = true;
            //update hubspot contact
            this.globals.updateERPNextCustomer();
            this.analyticsServices.trackingExpPos('starter', this.globals.tracking_exp['starter'], 'pos');
        }
    }

    async salesDay() {
        //
        var date_first = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
        var date_last = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
        //
        const body = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('datetime_init', date_first)
            .set('datetime_final', date_last);

        await this.http.post(this.globals.analytics_path + 'sales-day', body).subscribe(async data => {
            this.sales_day = data['total_amount'];
            this.total_tips = data['total_tips'];
            this.sales_tips = parseFloat(this.sales_day) + parseFloat(this.total_tips)
            this.total_elements_sold = data['total_elements'];
            this.data_sales_day = true;
        },
            err => {
            }
        );
    }

    openPOS() {
        // Si es la primera vez que entra (no ha terminado la configuración del POS)
        if (this.globals.restaurant.plg_pos_finisher == undefined || this.globals.restaurant.plg_pos_finisher == false) {
            this.globals.side_menu_active = 'tpv';
            this.navCtrl.setRoot(TpvPanelPage, {
                origin: 'tpv'
            });
        } else {
            // Si ya está activo, va a la página de sales
            this.globals.side_menu_active = 'sales';
            this.navCtrl.setRoot(SalesListPage);
        }
        this.globals.side_menu_active_analytics = false;
        this.globals.open_side_menu = false;
    }

    openLanding() {
        if (this.globals.so_mobile) {
            window.location.assign('https://landing.mycheftool.com/es/punto-de-venta');
        } else {
            window.open('https://landing.mycheftool.com/es/punto-de-venta', '_blank');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-cards/home-pos/home-pos.ts